import React from "react";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import AboutSection from "./components/AboutSection";

const About = () => {
  return (
    <div>
      <div className='boxcar-wrapper' style={{backgroundColor:"#050B20"}} >
       <div style={{paddingBottom:"220px"}} >
      <Header preclass="normal"  />
      </div>
      <AboutSection />
      <Footer />
      </div>
    </div>
  );
};

export default About;
